import styled, { css } from 'styled-components'

export const CardContainer = styled.div`
  padding: 1em;
  transition: ease all 150ms;
  //background: #017849;
  width: fit-content;
  border-radius: 10px;

  :hover {
    transform: scale(1.05);
  }
  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints[2]}) {
      width: 100%;
      min-width: 100%;
    }
  `}
`
export const ExternContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1em;

  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints[2]}) {
      flex-direction: column;
      flex-wrap: unset;
    }
  `}
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  button {
    margin-right: auto;
    cursor: pointer;
    color: #fff;
    border-radius: 5px;
    padding: 5px 10px;

    ${({ theme }) => css`
      background-color: ${theme.colors.primary};
    `}
  }

  > div {
    cursor: pointer;
    padding: 5px;
    border-radius: 50%;
  }
`

export const Label = styled.label``

export const BackDropCard = styled.div`
  ${({ theme }) => css`
    aspect-ratio: 8/5;
    width: 280px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    overflow: hidden;
    transition: ease all 150ms;
    border: 2px solid ${theme.colors.primary};
    cursor: pointer;

    :hover {
      //box-shadow: 0 0 0.5rem ${theme.colors.primary};
      //transform: scale(1.05);
    }

    @media (max-width: ${theme.breakpoints[2]}) {
      width: 100%;
      min-width: 100%;
    }
  `}
`

export const Card = styled.div`
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  // backdrop-filter: blur(15px);
  padding: 1em;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Field = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    label {
      font-size: ${theme.font.sizes.xxxsmall};
    }
    span {
      font-size: ${theme.font.sizes.normal};
      color: ${theme.colors.black};
      font-weight: bold;
      letter-spacing: 2px;

      img {
        width: 25%;
      }
    }

    span.active {
      color: ${theme.colors.primary};
      text-transform: uppercase;
    }
  `}
`

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  > :first-child {
    flex: 1;
  }
`
